import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import axios from "axios";
import "./App.css";

// All your pages & components (unchanged)
import Test from "./pages/Test";
import Upload from "./pages/Upload";
import Search from "./pages/Search";
import FlashData from "./pages/FlashData";
import BOM from "./pages/BOM";
import Binning from "./pages/Binning";
import Home from "./pages/Home";
import QualityLoss from "./pages/QualityLoss";
import ShipmentTracker from "./pages/ShipmentTracker";
import Sidebar from "./components/Sidebar/Sidebar";
import Navbar from "./components/Navbar/Navbar";
import Inspection from "./pages/Inspection";
import Section1 from "./components/Inspection/Sections/Section1";
import Section2 from "./components/Inspection/Sections/Section2";
import Section3 from "./components/Inspection/Sections/Section3";
import PdiWitness from "./pages/PdiWitness";
import ViewProjectDetails from "./components/Home/ViewProjectDetails";
import InspectionForm from "./components/Inspection/InspectionForms";
import ProcessFlowChart from "./components/Coming Soon Pages/ProcessFlowChart";
import ManagementSummury from "./components/Coming Soon Pages/ManagementSummury";
import GraphicalSummary from "./components/QualityInspectionSummary/GraphicalSummary/GraphicalSummary.js";
import DesignInputs from "./components/Table Wise Scanning/DesignInputs";
import SiteSupervisorInputs from "./components/Table Wise Scanning/SiteSupervisorInputs.js";
import SitePlannerTabs from "./components/Table Wise Scanning/Site Planner Tabs/SitePlannerTabs.js";
import ModuleReconciliation from "./components/Coming Soon Pages/ModuleReconciliation";
import NonConformance from "./components/Coming Soon Pages/NonConformance";
import ReleaseNotes from "./pages/ReleaseNotes";
import { UserProvider } from "./pages/UserContext.js";
import ViewInspection from "./components/Inspection/View_Inspection.js";
import QualityPanel from "./components/SupportDocuments/QualityPanel/QualityPanel.js";
import EngineeringPanel from "./components/SupportDocuments/EngineeringPanel/EngineeringPanel.js";
import ReceivingPanel from "./components/SupportDocuments/ReceivingPanel/ReceivingPanel.js";
import OpenForAllPanel from "./components/SupportDocuments/OpenForAllPanel/OpenForAllPanel.js";
import ReceivingTabsComponent from "./components/ReceivingModulesManagement/receivingSupplierTabs.js";
import VehicleInspection from "./components/ReceivingModulesManagement/VehicleInspection/VehicleInspection.js";
import ModuleFlaggedForm from "./components/ReceivingModulesManagement/InternalTabs/FlaggedModuleForm.js";
import QualityInspectionSummary from "./components/QualityInspectionSummary/QualityInspectionSummary.js";
import Reconciliation_Dashboard from "./components/ModuleReconciliationSheet/Reconciliation_Dashboard.js";
import DamagedModuleTabsComponent from "./components/ModuleReconciliationSheet/DamageModule/DamageModuleTabs.js";
import ReturnToStoreTabs from "./components/ModuleReconciliationSheet/DamageModule/ReturnToStore/ReturnToStoreTabs.js";
import UncountedModules from "./components/ModuleReconciliationSheet/UncountedModules.js";
import LandingPage from "./components/LandingPage.js";
import TrackerTab from "./components/AutomationReport/Tracker/TrackerTab.js";
import ReportMain from "./components/AutomationReport/ReportGenerator/ReportMain.js";

// NEW IMPORTS FOR PROTECTION
import RequireRole from "./pages/RequireRole"
import AccessDenied from "./pages/AccessDenied"; 

// KEYCLOAK HOOK
import useKeycloakAuth from "./hooks/useKeycloakAuth.js";
import apiClient from "./pages/keycloak/axiosInstance.js";

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // Keycloak auth state
  const { isLogin, isLoading, keycloak, username, roles, logout } = useKeycloakAuth();

  const toggleSidebar = () => setSidebarOpen(prev => !prev);

  // useEffect(() => {
  //   if (!keycloak) return;

  //   const requestInterceptor = apiClient.interceptors.request.use(
  //     async (config) => {
  //       try {
  //         await keycloak.updateToken(30);
  //         config.headers.Authorization = `Bearer ${keycloak.token}`;
  //       } catch {
  //         logout();
  //       }
  //       return config;
  //     }
  //   );

  //   return () => {
  //     apiClient.interceptors.request.eject(requestInterceptor);
  //   };
  // }, [keycloak, logout]);


  // Loading screen
  if (isLoading) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
        gap: "20px"
      }}>
        <div className="loader"></div>
        <p>Loading authentication...</p>
      </div>
    );
  }

  // Not authenticated → redirect to Keycloak login
  if (!isLogin) {
    keycloak?.login();
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column"
      }}>
        <h2>Redirecting to login...</h2>
      </div>
    );
  }

  // FULLY AUTHENTICATED APP
  return (
    <Router>
      <UserProvider>
        <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
          <Navbar
            sidebarOpen={sidebarOpen}
            toggleSidebar={toggleSidebar}
            handleLogout={logout}
            username={username}
          />

          <div style={{ display: "flex", flex: 1 }}>
            <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

            <main style={{
              flexGrow: 1,
              marginLeft: sidebarOpen ? 300 : 60,
              padding: "16px",
              overflow: "auto",
              width: `calc(100% - ${sidebarOpen ? "300px" : "60px"})`,
              transition: "margin 0.3s ease, width 0.3s ease",
              backgroundColor: "#f5f5f5"
            }}>
              <Routes>
                {/* Public / minimally protected routes */}
                <Route path="/landing-page" element={<LandingPage />} />
                <Route path="/test" element={<Test />} />
                <Route path="/ncr" element={<NonConformance />} />
                <Route path="/releasenotes" element={<ReleaseNotes />} />

                {/* Access Denied Page */}
                <Route path="/access-denied" element={<AccessDenied />} />

                {/* Protected routes */}
                <Route
                  path="/"
                  element={
                    <RequireRole requiredRole="Workspace_View">
                      <Home />
                    </RequireRole>
                  }
                />
                <Route
                  path="/home"
                  element={
                    <RequireRole requiredRole="Workspace_View">
                      <Home />
                    </RequireRole>
                  }
                />

                <Route
                  path="/process-flow-chart"
                  element={
                    <RequireRole requiredRole="Process_Flow_Chart_View">
                      <ProcessFlowChart />
                    </RequireRole>
                  }
                />
                <Route
                  path="/management-summary"
                  element={
                    <RequireRole requiredRole="Management_Summary_View">
                      <ManagementSummury />
                    </RequireRole>
                  }
                />
                <Route
                  path="/graphical-summary"
                  element={
                    <RequireRole requiredRole="Quality_Inspection_View">
                      <GraphicalSummary />
                    </RequireRole>
                  }
                />

                {/* Table-wise Scanning */}
                <Route
                  path="/table-wise-scanning/design-inputs"
                  element={
                    <RequireRole requiredRole="Design_Inputs_View">
                      <DesignInputs />
                    </RequireRole>
                  }
                />
                <Route
                  path="/table-wise-scanning/site-supervisor-inputs"
                  element={
                    <RequireRole requiredRole="Site_Supervisor_View">
                      <SiteSupervisorInputs />
                    </RequireRole>
                  }
                />
                <Route
                  path="/table-wise-scanning/site-planner-inputs"
                  element={
                    <RequireRole requiredRole="Site_Planner_View">
                      <SitePlannerTabs />
                    </RequireRole>
                  }
                />

                <Route
                  path="/module-reconciliation-sheet"
                  element={
                    <RequireRole requiredRole="Module_Reconciliation_Sheet_View">
                      <ModuleReconciliation />
                    </RequireRole>
                  }
                />

                {/* Manufacturing Traceability */}
                <Route
                  path="/manufacturing-traceability/upload"
                  element={
                    <RequireRole requiredRole="MT_Upload_View">
                      <Upload />
                    </RequireRole>
                  }
                />
                <Route
                  path="/manufacturing-traceability/search"
                  element={
                    <RequireRole requiredRole="Traceability_Search_View">
                      <Search />
                    </RequireRole>
                  }
                />
                <Route
                  path="/manufacturing-traceability/tracking"
                  element={
                    <RequireRole requiredRole="PDI_Verification_View">
                      <FlashData />
                    </RequireRole>
                  }
                />
                <Route
                  path="/manufacturing-traceability/bom"
                  element={
                    <RequireRole requiredRole="Manufacturing_Traceability_View">
                      <BOM />
                    </RequireRole>
                  }
                />
                <Route
                  path="/manufacturing-traceability/binning"
                  element={
                    <RequireRole requiredRole="Manufacturing_Traceability_View">
                      <Binning />
                    </RequireRole>
                  }
                />
                <Route
                  path="/manufacturing-traceability/quality-loss"
                  element={
                    <RequireRole requiredRole="Manufacturing_Traceability_View">
                      <QualityLoss />
                    </RequireRole>
                  }
                />
                <Route
                  path="/manufacturing-traceability/shipment-tracker"
                  element={
                    <RequireRole requiredRole="Shipment_Tracker_View">
                      <ShipmentTracker />
                    </RequireRole>
                  }
                />
                <Route
                  path="/manufacturing-traceability/pdi-witness"
                  element={
                    <RequireRole requiredRole="PDI_Witness_View">
                      <PdiWitness />
                    </RequireRole>
                  }
                />

                {/* Inspections */}
                <Route
                  path="/inspections"
                  element={
                    <RequireRole requiredRole="Inspections_View">
                      <Inspection />
                    </RequireRole>
                  }
                />
                <Route
                  path="/inspections/section1/:formId"
                  element={
                    <RequireRole requiredRole="Inspections_View">
                      <Section1 />
                    </RequireRole>
                  }
                />
                <Route
                  path="/inspections/section2/:formId"
                  element={
                    <RequireRole requiredRole="Inspections_View">
                      <Section2 />
                    </RequireRole>
                  }
                />
                <Route
                  path="/inspections/section3/:formId"
                  element={
                    <RequireRole requiredRole="Inspections_View">
                      <Section3 />
                    </RequireRole>
                  }
                />
                <Route
                  path="/inspections/forms"
                  element={
                    <RequireRole requiredRole="Inspections_View">
                      <InspectionForm />
                    </RequireRole>
                  }
                />
                <Route
                  path="/view-inspection"
                  element={
                    <RequireRole requiredRole="Inspections_View">
                      <ViewInspection />
                    </RequireRole>
                  }
                />

                <Route
                  path="/view-project-details/:projectId"
                  element={
                    <RequireRole requiredRole="Workspace_View">
                      <ViewProjectDetails />
                    </RequireRole>
                  }
                />

                {/* Support Documents */}
                <Route
                  path="/support-documents/quality"
                  element={
                    <RequireRole requiredRole="SD_Quality_View">
                      <QualityPanel />
                    </RequireRole>
                  }
                />
                <Route
                  path="/support-documents/engineering"
                  element={
                    <RequireRole requiredRole="SD_Engineering_View">
                      <EngineeringPanel />
                    </RequireRole>
                  }
                />
                <Route
                  path="/support-documents/receiving"
                  element={
                    <RequireRole requiredRole="SD_Receiving_View">
                      <ReceivingPanel />
                    </RequireRole>
                  }
                />
                <Route
                  path="/support-documents/open-for-all"
                  element={
                    <RequireRole requiredRole="SD_Open_For_All_View">
                      <OpenForAllPanel />
                    </RequireRole>
                  }
                />

                {/* Receiving Modules */}
                <Route
                  path="/receiving-modules"
                  element={
                    <RequireRole requiredRole="Receiving_Modules_View">
                      <ReceivingTabsComponent />
                    </RequireRole>
                  }
                />
                <Route
                  path="/vehicle-inspection"
                  element={
                    <RequireRole requiredRole="Receiving_Modules_View">
                      <VehicleInspection />
                    </RequireRole>
                  }
                />
                <Route
                  path="/module-flagged-form"
                  element={
                    <RequireRole requiredRole="Receiving_Modules_View">
                      <ModuleFlaggedForm />
                    </RequireRole>
                  }
                />

                <Route
                  path="/quality-inspection-summary"
                  element={
                    <RequireRole requiredRole="Quality_Inspection_View">
                      <QualityInspectionSummary />
                    </RequireRole>
                  }
                />

                {/* Module Reconciliation sub-pages */}
                <Route
                  path="/module-reconciliation-sheet/module-reconciliation-dashboard"
                  element={
                    <RequireRole requiredRole="Module_Reconciliation_Dashboard_View">
                      <Reconciliation_Dashboard />
                    </RequireRole>
                  }
                />
                <Route
                  path="/module-reconciliation-sheet/module-reconciliation-damaged"
                  element={
                    <RequireRole requiredRole="Damaged_Module_Information_View">
                      <DamagedModuleTabsComponent />
                    </RequireRole>
                  }
                />
                <Route
                  path="/module-reconciliation-sheet/module-reconciliation-Store"
                  element={
                    <RequireRole requiredRole="Return_to_Store_View">
                      <ReturnToStoreTabs />
                    </RequireRole>
                  }
                />
                <Route
                  path="/module-reconciliation-sheet/module-reconciliation-Unaccounted"
                  element={
                    <RequireRole requiredRole="Unaccounted_Modules_View">
                      <UncountedModules />
                    </RequireRole>
                  }
                />

                {/* Automated Report */}
                <Route
                  path="/automated-report/report-tracker"
                  element={
                    <RequireRole requiredRole="Automatic_Report_Tracker_View">
                      <TrackerTab />
                    </RequireRole>
                  }
                />
                <Route
                  path="/automated-report/report-form"
                  element={
                    <RequireRole requiredRole="Automatic_Report_Form_View">
                      <ReportMain />
                    </RequireRole>
                  }
                />

                {/* Catch-all redirect */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
          </div>
        </div>
      </UserProvider>
    </Router>
  );
}

export default App;

{/* Alternative simplified App.js with Firebase based Authentication */}

// import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
// import { onAuthStateChanged, signOut } from "firebase/auth";
// import { auth } from "./firebase";
// import Login from "./pages/Login.js";
// import Test from "./pages/Test";
// import "./App.css"; // Ensure the CSS file is imported
// import Upload from "./pages/Upload";
// import Search from "./pages/Search";
// import FlashData from "./pages/FlashData";
// import BOM from "./pages/BOM";
// import Binning from "./pages/Binning";
// import Home from "./pages/Home";
// import QualityLoss from "./pages/QualityLoss";
// import ShipmentTracker from "./pages/ShipmentTracker";
// import Sidebar from "./components/Sidebar/Sidebar";
// import Navbar from "./components/Navbar/Navbar";
// import Inspection from "./pages/Inspection";
// import Section1 from "./components/Inspection/Sections/Section1";
// import Section2 from "./components/Inspection/Sections/Section2";
// import Section3 from "./components/Inspection/Sections/Section3";
// import PdiWitness from "./pages/PdiWitness";
// import ViewProjectDetails from "./components/Home/ViewProjectDetails";
// import InspectionForm from "./components/Inspection/InspectionForms";
// import ProcessFlowChart from "./components/Coming Soon Pages/ProcessFlowChart";
// import ManagementSummury from "./components/Coming Soon Pages/ManagementSummury";
// import GraphicalSummary from "./components/QualityInspectionSummary/GraphicalSummary/GraphicalSummary.js";
// import DesignInputs from "./components/Table Wise Scanning/DesignInputs";
// import SiteSupervisorInputs from "./components/Table Wise Scanning/SiteSupervisorInputs.js";
// import SitePlannerTabs from "./components/Table Wise Scanning/Site Planner Tabs/SitePlannerTabs.js";
// import ModuleReconciliation from "./components/Coming Soon Pages/ModuleReconciliation";
// import NonConformance from "./components/Coming Soon Pages/NonConformance";
// import ReleaseNotes from "./pages/ReleaseNotes";
// import { UserProvider } from "./pages/UserContext.js";
// import ViewInspection from "./components/Inspection/View_Inspection.js";
// import QualityPanel from './components/SupportDocuments/QualityPanel/QualityPanel.js';
// import EngineeringPanel from './components/SupportDocuments/EngineeringPanel/EngineeringPanel.js';
// import ReceivingPanel from './components/SupportDocuments/ReceivingPanel/ReceivingPanel.js';
// import OpenForAllPanel from './components/SupportDocuments/OpenForAllPanel/OpenForAllPanel.js';
// import ReceivingTabsComponent from "./components/ReceivingModulesManagement/receivingSupplierTabs.js";
// import VehicleInspection from "./components/ReceivingModulesManagement/VehicleInspection/VehicleInspection.js";
// import ModuleFlaggedForm from "./components/ReceivingModulesManagement/InternalTabs/FlaggedModuleForm.js";
// import QualityInspectionSummary from "./components/QualityInspectionSummary/QualityInspectionSummary.js";
// import Reconciliation_Dashboard from "./components/ModuleReconciliationSheet/Reconciliation_Dashboard.js";
// import DamagedModuleTabsComponent from "./components/ModuleReconciliationSheet/DamageModule/DamageModuleTabs.js";
// import ReturnToStoreTabs from "./components/ModuleReconciliationSheet/DamageModule/ReturnToStore/ReturnToStoreTabs.js";
// import UncountedModules from "./components/ModuleReconciliationSheet/UncountedModules.js";
// import LandingPage from "./components/LandingPage.js";
// import TrackerTab from "./components/AutomationReport/Tracker/TrackerTab.js";
// import ReportMain from "./components/AutomationReport/ReportGenerator/ReportMain.js";

// function App() {
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [isLogin, setIsLogin] = useState(false); // Track login state
//   const [isLoading, setIsLoading] = useState(true); // Track loading state

//   // Toggle sidebar function
//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };



//   // Firebase authentication state observer
//   useEffect(() => {

//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth', // Optional: Adds smooth scrolling animation
//     });

//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         setIsLogin(true); // User is logged in
//       } else {
//         setIsLogin(false); // User is logged out
//       }
//       setIsLoading(false); // Authentication check is complete
//     });

//     return () => unsubscribe(); // Cleanup observer on unmount
//   }, []);

//   // Handle logout
//   const handleLogout = async () => {
//     try {
//       await signOut(auth);
//       setIsLogin(false); // Update login state
//     } catch (error) {
//       console.error("Error logging out:", error);
//     }
//   };

//   // Show a loading spinner while Firebase is initializing
//   if (isLoading) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
//         <div className="loader"></div>
//       </div>
//     );
//   }

//   // Render the application
//   return (
//     <Router>
//       <Routes>
//         {/* Default route: Redirect to Login if not authenticated */}
//         <Route
//           path="/"
//           element={isLogin ? <Navigate to="/home" /> : <Login />}
//         />

//         {/* Protected routes: Only accessible if authenticated */}
//         {isLogin && (
//           <Route
//             path="*"
//             element={
//               <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
//                 <UserProvider>
//                   <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} handleLogout={handleLogout} />
//                   <div style={{ display: "flex", flex: 1 }}>
//                     <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
//                     <main
//                       style={{
//                         flexGrow: 1,
//                         marginLeft: sidebarOpen ? 300 : 60,
//                         padding: "0px 0px 0px 1px",
//                         overflow: "auto",
//                         width: `calc(100% - ${sidebarOpen ? '300px' : '60px'})`,
//                       }}
//                     >
//                       <Routes>
//                         <Route path="/" element={<Login />} />
//                         <Route path="/home" element={<Home />} />
//                         <Route path="/test" element={<Test />} />
//                         <Route path="/landing-page" element={<LandingPage />} />
//                         <Route path="/process-flow-chart" element={<ProcessFlowChart />} />
//                         <Route path="/management-summary" element={<ManagementSummury />} />
//                         <Route path="/graphical-summary" element={<GraphicalSummary />} />
//                         <Route path="/table-wise-scanning/design-inputs" element={<DesignInputs />} />
//                         <Route path="/table-wise-scanning/site-supervisor-inputs" element={<SiteSupervisorInputs />} />
//                         <Route path="/table-wise-scanning/site-planner-inputs" element={<SitePlannerTabs />} />
//                         <Route path="/module-reconciliation-sheet" element={<ModuleReconciliation />} />
//                         <Route path="/ncr" element={<NonConformance />} />
//                         <Route path="/manufacturing-traceability/upload" element={<Upload />} />
//                         <Route path="/manufacturing-traceability/search" element={<Search />} />
//                         <Route path="/manufacturing-traceability/tracking" element={<FlashData />} />
//                         <Route path="/manufacturing-traceability/bom" element={<BOM />} />
//                         <Route path="/manufacturing-traceability/binning" element={<Binning />} />
//                         <Route path="/manufacturing-traceability/quality-loss" element={<QualityLoss />} />
//                         <Route path="/manufacturing-traceability/shipment-tracker" element={<ShipmentTracker />} />
//                         <Route path="/inspections" element={<Inspection />} />
//                         <Route path="/inspections/section1/:formId" element={<Section1 />} />
//                         <Route path="/inspections/section2/:formId" element={<Section2 />} />
//                         <Route path="/inspections/section3/:formId" element={<Section3 />} />
//                         <Route path="/manufacturing-traceability/pdi-witness" element={<PdiWitness />} />
//                         <Route path="/view-project-details/:projectId" element={<ViewProjectDetails />} />
//                         <Route path="/inspections/forms" element={<InspectionForm />} />
//                         <Route path="/releasenotes" element={<ReleaseNotes />} />
//                         <Route path="/view-inspection" element={<ViewInspection />} />
//                         <Route path="/support-documents/quality" element={<QualityPanel />} />
//                         <Route path="/support-documents/engineering" element={<EngineeringPanel />} />
//                         <Route path="/support-documents/receiving" element={<ReceivingPanel />} />
//                         <Route path="/support-documents/open-for-all" element={<OpenForAllPanel />} />
//                         <Route path="/receiving-modules" element={<ReceivingTabsComponent />} /> 
//                         <Route path="/vehicle-inspection" element={<VehicleInspection />} />
//                         <Route path="/module-flagged-form" element={<ModuleFlaggedForm />} />
//                         <Route path="/quality-inspection-summary" element={<QualityInspectionSummary />} />
//                         <Route path="/module-reconciliation-sheet/module-reconciliation-dashboard" element={<Reconciliation_Dashboard />} />
//                         <Route path="/module-reconciliation-sheet/module-reconciliation-damaged" element={<DamagedModuleTabsComponent />} />
//                         <Route path="/module-reconciliation-sheet/module-reconciliation-Store" element={<ReturnToStoreTabs />} />
//                         <Route path="/module-reconciliation-sheet/module-reconciliation-Unaccounted" element={<UncountedModules />} />
//                         <Route path="/automated-report/report-tracker" element={<TrackerTab />} />
//                         <Route path="/automated-report/report-form" element={<ReportMain />} />
//                         {/* Add more routes here */}
//                       </Routes>
//                     </main>
//                   </div>
//                 </UserProvider>
//               </div>
//             }
//           />
//         )}

//         {/* Redirect all other routes to Login if not authenticated */}
//         {!isLogin && (
//           <Route path="*" element={<Navigate to="/" />} />
//         )}
//       </Routes>
//     </Router>
//   );
// }

// export default App;